import { Directive, ElementRef, HostListener } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Directive({
    selector: '[thumb]',
})
export class ThumbDirective {
    el: HTMLElement;
    img: HTMLImageElement;
    video: HTMLVideoElement;
    moments: number[] = [];
    duration = 10;
    interval;
    isPlaying = false;
    constructor(private sourceEl: ElementRef) {
        this.el = sourceEl.nativeElement;
    }

    ngAfterViewInit(): void {
        this.img = <HTMLImageElement>this.el.children[0].children.item(0);
        this.video = <HTMLVideoElement>this.el.children[0].children.item(1);
        this.video.onloadedmetadata = () => {
            this.generateMoments();
        }

        this.video.addEventListener('mouseover', () => {
            this.hover();
        });
        this.video.addEventListener('mouseout', () => {
            this.end();
        })
    }

    hover() {
        this.video.style.opacity = '1';
        if (!this.isPlaying) {
            this.video.play();
            this.isPlaying = true;
        }
        let i = 0;
        this.video.currentTime = parseFloat(this.moments[i].toString());
        this.interval = setInterval(() => {
            if (i == 5) {
                this.end();
            }
            if (this.video.currentTime > this.moments[i] + this.duration && i < 5) {
                i++;
                this.video.currentTime = parseFloat(this.moments[i].toString());
            }
        }, 1000);
    }

    private end() {
        this.isPlaying = false;
        this.video.style.opacity = '0';
        this.video.pause();
        clearInterval(this.interval);
    }
    private generateMoments() {
        for (let i = 0; i < 5; i++) {
            const moment = Math.floor(Math.random() * this.video.duration);
            if (!this.moments.find(x => x + 10 == moment)) {
                this.moments.push(Math.floor(Math.random() * this.video.duration));
            }
        }
    }
}